import { render, staticRenderFns } from "./bridge.vue?vue&type=template&id=b8da0db6&scoped=true&"
import script from "./bridge.vue?vue&type=script&lang=js&"
export * from "./bridge.vue?vue&type=script&lang=js&"
import style0 from "./bridge.vue?vue&type=style&index=0&id=b8da0db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8da0db6",
  null
  
)

export default component.exports